import { IPaginationDTO, IPaginationResponse } from '@/models/pagination.model';

export enum WebsitesEndpoint {
  ROOT = '/websites',
  ADMIN = '/admin',
  REORDER = '/reorder',
}

export const staticWebsitesEndpoints = {
  GET_WEBSITES: `${WebsitesEndpoint.ROOT}${WebsitesEndpoint.ADMIN}`,
  CREATE_WEBSITE: WebsitesEndpoint.ROOT,
  REORDER_WEBSITES: `${WebsitesEndpoint.ROOT}${WebsitesEndpoint.REORDER}`,
};

export const getWebsitesEndpoints = ({ id }: { id: string }) => ({
  UPDATE_WEBSITE: `${WebsitesEndpoint.ROOT}/${id}`,
  DELETE_WEBSITE: `${WebsitesEndpoint.ROOT}/${id}`,
});

// ============== Model ==============

export enum WebsitesStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export interface IImage {
  id: string;
  file: {
    url: string;
    id: string;
  };
  metaType: 'banner';
}

// ============== DTO ==============

export type IDeleteWebsitesDTO = {
  id?: string;
};

export interface IReorderWebsitesDTO {
  showcaseChannelId: number;
  items: { id?: string; position?: number }[];
}

export type IGetWebsitesOptionsDTO = IPaginationDTO & {
  showcaseChannelId?: number;
  pageSize: number;
  page: number;
};

export interface IWebsiteFile {
  id: string;
  name: string;
  type: string;
  mimeType: string;
  url: string;
}

export interface IWebsiteFiles {
  id: string;
  relatedId: string;
  relatedType: string;
  fileId: string;
  metaType: string;
  unique: boolean;
  createdAt: string;
  updatedAt: string;
  file: IWebsiteFile;
}

export interface ICreateWebsitesDataDTO {
  id?: string;
  channelId: number;
  showcaseChannelId?: number;
  title: string;
  description: string;
  imageTitle?: string;
  position?: number;
  status?: WebsitesStatus;
  image?: string;
  createdAt?: string;
  updatedAt?: string;
  files?: IWebsiteFiles[];
}

export type IUpdateWebsitesDataDTO = Omit<ICreateWebsitesDataDTO, 'channelId'>;

export type IWebsites = ICreateWebsitesDataDTO;

// ============== Response ==============

export type ICreateWebsitesResponse = IWebsites;

export type IUpdateWebsitesResponse = IWebsites;

export type IDeleteWebsitesResponse = string;

export type TGetWebsitesResponse = IPaginationResponse & {
  websites: IWebsites[];
};
